import { supabase } from './supabase.ts';

export const metricsService = {
  async getDashboardMetrics() {
    const today = new Date();
    const currentMonth = today.getMonth();
    const currentYear = today.getFullYear();

    const [
      properties,
      payments,
      bills,
      tenants,
      maintenanceRecords
    ] = await Promise.all([
      supabase.from('properties').select('*'),
      supabase.from('payments').select('*'),
      supabase.from('bills').select('*'),
      supabase.from('tenants').select('*'),
      supabase.from('maintenance_records').select('*')
    ]);

    // Calculate collection rate
    const monthlyBills = bills.data?.filter(bill => {
      const billDate = new Date(bill.due_date);
      return billDate.getMonth() === currentMonth && billDate.getFullYear() === currentYear;
    }) || [];

    const monthlyPayments = payments.data?.filter(payment => {
      const paymentDate = new Date(payment.payment_date);
      return paymentDate.getMonth() === currentMonth && paymentDate.getFullYear() === currentYear;
    }) || [];

    const collectionRate = monthlyBills.length > 0 
      ? (monthlyPayments.length / monthlyBills.length) * 100 
      : 0;

    // Calculate average tenant duration
    const completedTenancies = tenants.data?.filter(tenant => 
      tenant.end_date && new Date(tenant.end_date) < today
    ) || [];

    const averageTenancyDays = completedTenancies.length > 0
      ? completedTenancies.reduce((sum, tenant) => {
          const start = new Date(tenant.start_date);
          const end = new Date(tenant.end_date!);
          return sum + (end.getTime() - start.getTime()) / (1000 * 3600 * 24);
        }, 0) / completedTenancies.length
      : 0;

    // Calculate property utilization
    const totalProperties = properties.data?.length || 0;
    const occupiedProperties = properties.data?.filter(p => p.status === 'Rented').length || 0;
    const utilizationRate = totalProperties > 0 
      ? (occupiedProperties / totalProperties) * 100 
      : 0;

    // Calculate maintenance costs
    const yearlyMaintenance = maintenanceRecords.data?.reduce((sum, record) => {
      const recordDate = new Date(record.start_date);
      if (recordDate.getFullYear() === currentYear) {
        return sum + record.cost;
      }
      return sum;
    }, 0) || 0;

    return {
      collectionRate,
      averageTenancyMonths: Math.round(averageTenancyDays / 30),
      utilizationRate,
      yearlyMaintenance,
      occupiedProperties,
      totalProperties
    };
  }
};
